import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import PropTypes from "prop-types";

export default function BasicTimePicker({ props, setFieldValue, handleChangeEvent }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['TimePicker']}>
       <TimePicker
  ampm={false}
  format="HH:mm"
  referenceDate={dayjs()}
  timeSteps={{ minutes: 1 }}
  localeText={{
    fieldHoursPlaceholder: () => "HH",
    fieldMinutesPlaceholder: () => "MM",
  }}
  onChange={(newValue) => {
    const e = {
      target: {
        name: props?.name,
        value: newValue ? dayjs(newValue).format('HH:mm') : '',
      },
    };
    if (props?.handleChange) props?.handleChange?.(e, setFieldValue);
    handleChangeEvent(e);
  }}
/>
      </DemoContainer>
    </LocalizationProvider>
  );
}

BasicTimePicker.propTypes = {
  props: PropTypes.shape({
    name: PropTypes.string,
    handleChange: PropTypes.func,
  }),
  setFieldValue: PropTypes.func,
  handleChangeEvent: PropTypes.func.isRequired,
};